import { createContextWithRoot } from '@patternfly/pfe-core/functions/context.js';

export const rhJumpLinksOrientationContext =
  createContextWithRoot(Symbol('rh-jump-links[orientation]'));
